var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoIntegrationDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9367 22.1378C14.9367 18.6423 17.7704 15.8086 21.266 15.8086C24.7615 15.8086 27.5952 18.6423 27.5952 22.1378C27.5952 25.6333 24.7615 28.467 21.266 28.467C17.7704 28.467 14.9367 25.6333 14.9367 22.1378ZM21.266 17.1384C18.5048 17.1384 16.2665 19.3767 16.2665 22.1378C16.2665 24.8989 18.5048 27.1372 21.266 27.1372C24.0271 27.1372 26.2654 24.8989 26.2654 22.1378C26.2654 19.3767 24.0271 17.1384 21.266 17.1384Z",
    fill: "#55595F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2369 17.7802C33.2369 15.2472 35.2903 13.1938 37.8232 13.1938C40.3562 13.1938 42.4096 15.2472 42.4096 17.7802C42.4096 20.3132 40.3562 22.3665 37.8232 22.3665C35.2903 22.3665 33.2369 20.3132 33.2369 17.7802ZM37.8232 14.5236C36.0247 14.5236 34.5667 15.9816 34.5667 17.7802C34.5667 19.5787 36.0247 21.0368 37.8232 21.0368C39.6218 21.0368 41.0798 19.5787 41.0798 17.7802C41.0798 15.9816 39.6218 14.5236 37.8232 14.5236Z",
    fill: "#55595F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6796 4.70891C16.6796 2.17594 18.733 0.122559 21.2659 0.122559C23.7989 0.122559 25.8523 2.17594 25.8523 4.70891C25.8523 7.24188 23.7989 9.29526 21.2659 9.29526C18.733 9.29526 16.6796 7.24188 16.6796 4.70891ZM21.2659 1.45235C19.4674 1.45235 18.0094 2.91036 18.0094 4.70891C18.0094 6.50746 19.4674 7.96547 21.2659 7.96547C23.0645 7.96547 24.5225 6.50746 24.5225 4.70891C24.5225 2.91036 23.0645 1.45235 21.2659 1.45235Z",
    fill: "#55595F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.122345 17.7802C0.122345 15.2472 2.17572 13.1938 4.7087 13.1938C7.24167 13.1938 9.29505 15.2472 9.29505 17.7802C9.29505 20.3132 7.24167 22.3665 4.7087 22.3665C2.17572 22.3665 0.122345 20.3132 0.122345 17.7802ZM4.7087 14.5236C2.91015 14.5236 1.45213 15.9816 1.45213 17.7802C1.45213 19.5787 2.91015 21.0368 4.7087 21.0368C6.50725 21.0368 7.96526 19.5787 7.96526 17.7802C7.96526 15.9816 6.50725 14.5236 4.7087 14.5236Z",
    fill: "#55595F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.09381 36.9521C7.09381 34.4191 9.14719 32.3657 11.6802 32.3657C14.2131 32.3657 16.2665 34.4191 16.2665 36.9521C16.2665 39.485 14.2131 41.5384 11.6802 41.5384C9.14719 41.5384 7.09381 39.485 7.09381 36.9521ZM11.6802 33.6955C9.88161 33.6955 8.4236 35.1535 8.4236 36.9521C8.4236 38.7506 9.88161 40.2086 11.6802 40.2086C13.4787 40.2086 14.9367 38.7506 14.9367 36.9521C14.9367 35.1535 13.4787 33.6955 11.6802 33.6955Z",
    fill: "#55595F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2654 36.9521C26.2654 34.4191 28.3188 32.3657 30.8517 32.3657C33.3847 32.3657 35.4381 34.4191 35.4381 36.9521C35.4381 39.485 33.3847 41.5384 30.8517 41.5384C28.3188 41.5384 26.2654 39.485 26.2654 36.9521ZM30.8517 33.6955C29.0532 33.6955 27.5952 35.1535 27.5952 36.9521C27.5952 38.7506 29.0532 40.2086 30.8517 40.2086C32.6503 40.2086 34.1083 38.7506 34.1083 36.9521C34.1083 35.1535 32.6503 33.6955 30.8517 33.6955Z",
    fill: "#55595F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7978 8.63037V16.1527H20.7339V8.63037H21.7978Z",
    fill: "#55595F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0821 27.6546L14.0063 33.7683L13.1211 33.1782L17.197 27.0645L18.0821 27.6546Z",
    fill: "#55595F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4635 27.0645L28.5393 33.1782L27.6542 33.7683L23.5783 27.6546L24.4635 27.0645Z",
    fill: "#55595F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.24312 18.4424L16.2467 20.4433L15.9887 21.4753L7.98511 19.4744L8.24312 18.4424Z",
    fill: "#55595F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2888 18.4424L34.5468 19.4744L26.5433 21.4753L26.2852 20.4433L34.2888 18.4424Z",
    fill: "#55595F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoIntegrationDevices);
export default __webpack_public_path__ + "static/media/NoIntegrationDevices.99d1feedad10d6e240e015be3a363ab5.svg";
export { ForwardRef as ReactComponent };